"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationStatusResponseDataVerificationTypeEnum = exports.VerificationStatusResponseDataStatusEnum = void 0;
exports.instanceOfVerificationStatusResponseData = instanceOfVerificationStatusResponseData;
exports.VerificationStatusResponseDataFromJSON = VerificationStatusResponseDataFromJSON;
exports.VerificationStatusResponseDataFromJSONTyped = VerificationStatusResponseDataFromJSONTyped;
exports.VerificationStatusResponseDataToJSON = VerificationStatusResponseDataToJSON;
exports.VerificationStatusResponseDataToJSONTyped = VerificationStatusResponseDataToJSONTyped;
/**
 * @export
 */
exports.VerificationStatusResponseDataStatusEnum = {
    Verified: 'verified',
    RequiresInput: 'requires_input',
    Canceled: 'canceled',
    Processing: 'processing',
    Expired: 'expired'
};
/**
 * @export
 */
exports.VerificationStatusResponseDataVerificationTypeEnum = {
    StripeId: 'stripe_id',
    Manual: 'manual',
    Other: 'other'
};
/**
 * Check if a given object implements the VerificationStatusResponseData interface.
 */
function instanceOfVerificationStatusResponseData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function VerificationStatusResponseDataFromJSON(json) {
    return VerificationStatusResponseDataFromJSONTyped(json, false);
}
function VerificationStatusResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'verificationType': json['verificationType'] == null ? undefined : json['verificationType'],
        'stripeVerificationSessionId': json['stripeVerificationSessionId'] == null ? undefined : json['stripeVerificationSessionId'],
        'stripeVerificationReportId': json['stripeVerificationReportId'] == null ? undefined : json['stripeVerificationReportId'],
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'verifiedAt': json['verifiedAt'] == null ? undefined : (new Date(json['verifiedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}
function VerificationStatusResponseDataToJSON(json) {
    return VerificationStatusResponseDataToJSONTyped(json, false);
}
function VerificationStatusResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'verificationType': value['verificationType'],
        'stripeVerificationSessionId': value['stripeVerificationSessionId'],
        'stripeVerificationReportId': value['stripeVerificationReportId'],
        'failureReason': value['failureReason'],
        'verifiedAt': value['verifiedAt'] == null ? value['verifiedAt'] : value['verifiedAt'].toISOString(),
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
    };
}
